import {Configuration, LogLevel, PopupRequest} from "@azure/msal-browser";

const MSAL_TENANT_ID = process.env.REACT_APP_MSAL_TENANT_ID;
// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${MSAL_TENANT_ID}`,
        redirectUri: "/entra/redirect",
        postLogoutRedirectUri: "/",
        navigateToLoginRequestUrl: false, // Évite les redirections inutiles
    },
    cache: {
        cacheLocation: "sessionStorage", // Utilise sessionStorage pour persister la session
    },
    system: {
        allowPlatformBroker: false,
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                console.log(message);
            },
            piiLoggingEnabled: false,
            logLevel: LogLevel.Info,
        }
    },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["User.Read"],
};

export const teamsRequest: PopupRequest = {
    scopes: ["Team.ReadBasic.All", "User.Read"],
};

export const channelsRequest: PopupRequest = {
    scopes: ["Channel.ReadBasic.All", "Channel.Create"],
};

export const messageRequest: PopupRequest = {
    scopes: ["ChannelMessage.Send", "ChannelMessage.Read.All"],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphTeamsEndpoint: "https://graph.microsoft.com/v1.0/me/joinedTeams",
    graphChannelsEndpoint: (teamId: string) => `https://graph.microsoft.com/v1.0/teams/${teamId}/channels`,
    graphSendMessageEndpoint: (teamId: string, channelId: string) => `https://graph.microsoft.com/v1.0/teams/${teamId}/channels/${channelId}/messages`,
    graphChannelMessagesEndpoint: (teamId: string, channelId: string) => `https://graph.microsoft.com/v1.0/teams/${teamId}/channels/${channelId}/messages`,
    graphCreateChannelEndpoint: (teamId: string) => `https://graph.microsoft.com/v1.0/teams/${teamId}/channels`,
};


export const auth0Config = {
    domain: process.env.REACT_APP_AUTH_DOMAIN,
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
    // clientId: "uogXsA6sD0aktAvjSOrOScdfjq52vNU3",
    // audience: "https://poc-teams.mylectra.com",
    redirectUri: `${window.location.origin}/auth0/redirect`,
}